import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteMyCharacter } from '~/api';
import { DeleteMyCharacterRequest, GetMyCreationListResponse } from '~/types';
import useToast from '~/store/useToast';
import userKey from '../user/userKey';
import characterKey from './characterKey';

const useDeleteMyCharacterMutation = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  const deleteMyCreation = (request: DeleteMyCharacterRequest) => {
    const prev = queryClient.getQueryData<GetMyCreationListResponse>(
      userKey.getMyCreation(),
    );
    if (prev) {
      queryClient.setQueryData(userKey.getMyCreation(), {
        ...prev,
        data: prev.data.filter((e) => e.character_id !== request.character_id),
      });
    }
  };
  const deleteMyFavorite = (request: DeleteMyCharacterRequest) => {
    const prev = queryClient.getQueryData<GetMyCreationListResponse>(
      userKey.getMyFavorite(),
    );
    if (prev) {
      queryClient.setQueryData(userKey.getMyFavorite(), {
        ...prev,
        data: prev.data.filter((e) => e.character_id !== request.character_id),
      });
    }
  };

  return useMutation({
    mutationFn: deleteMyCharacter,
    onError: (error) => {
      console.error(error);
      showToast('error', 'delete failed');
    },
    onSuccess: ({ status }, request) => {
      deleteMyCreation(request);

      queryClient.invalidateQueries({
        queryKey: characterKey.all,
        refetchType: 'inactive',
      });
    },
  });
};

export default useDeleteMyCharacterMutation;
